import combineReducers from '@americanexpress/vitruvius/immutable';
import { proceduresReducer } from 'iguazu-rpc';
import { resourcesReducer } from 'iguazu-rest';
import { OneCache } from 'fetchye-one-app';
import postPropsReducer from './reducers/postPropsReducer';
import urlReducer from './reducers/urlReducer';

export const reducer = combineReducers({
  procedures: proceduresReducer,
  resources: resourcesReducer,
  postProps: postPropsReducer,
  url: urlReducer,
  fetchye: OneCache().reducer,
});

export default reducer;
